import * as stylex from '@stylexjs/stylex';
import { clsx } from 'clsx';
import { colors } from '../theme/colors.stylex';
import type { ExternalLinkProps } from './ExternalLink.types';

const styles = stylex.create({
  link: {
    display: 'inline-flex',
    color: colors.link,
    textDecorationLine: 'underline',
    textUnderlineOffset: '2px',
    transitionProperty: 'color, background-color, border-color, outline-color, text-decoration-color, fill, stroke',
    transitionDuration: '150ms',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  icon: { color: 'inherit', textDecorationLine: 'inherit' },
  label: { color: colors.bodyText, flexShrink: 0 },
});

/** Renders an external anchor with an optional leading label. */
export const ExternalLink = ({
  variant = 'link',
  label,
  href,
  children,
  extraClassNames = '',
  xstyle,
  testId,
  onClick,
}: ExternalLinkProps) => {
  const styleProps = stylex.props(styles[variant], xstyle);
  return (
    <>
      {label && <span {...stylex.props(styles.label)}>{label}</span>}
      <a
        href={href}
        target="_blank"
        rel="noopener"
        {...styleProps}
        className={clsx(styleProps.className, extraClassNames)}
        data-testid={testId}
        onClick={onClick}>
        {children}
      </a>
    </>
  );
};
export default ExternalLink;
